import { StateCreator } from "zustand";
import { FetchState } from "../../../domain/models/fetch-state";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";
import {
  AUTH_HEADER,
  SECURE_AUTH_TOKEN_KEY,
  SECURE_BASE_URL_KEY,
} from "../../../base";
import Endpoints from "../../../domain/endpoints";
import { AddUploadFileExpenseType } from "../../../domain/useages/expense-dashboard/add-upload-file-expense";
import { RemoteAddUploadFileExpense } from "../../../data/usecases/expense-dashboard/remote-add-upload-file-expense";

export interface AddUploadFileExpenseInterface {
  AddUploadFileExpenseState: FetchState;
  addUploadFileExpense: Function;
}

const initialStates = {
  AddUploadFileExpenseState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();

export const useAddUploadFileExpenseSlice: StateCreator<
  AddUploadFileExpenseInterface
> = (set, get) => ({
  ...initialStates,
  addUploadFileExpense: async (
    payload: AddUploadFileExpenseType.Params
  ) => {
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ?? "";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteAddUploadFileExpense =
      new RemoteAddUploadFileExpense(
        `${BASE_URL}${Endpoints.ADD_UPLOAD_FILE_EXPENSE}`,
        axiosHttpClient
      );

    let result = await remoteAddUploadFileExpense.add(payload);
    return result;
  },
});
